module.exports = __webpack_public_path__ + "static/media/state-clear.1f318f47.png";